import type { InputProps } from '@chakra-ui/react'
import { Flex, forwardRef, Input } from '@chakra-ui/react'
import { Czech } from 'flatpickr/dist/l10n/cs'
import type { BaseOptions } from 'flatpickr/dist/types/options'
import moment from 'moment'
import type { ChangeEventHandler } from 'react'
import { useEffect, useRef, useState } from 'react'
import Flatpickr from 'react-flatpickr'

import { Calendar } from '../icons'

interface DatepickerPopupProps extends InputProps {
  date?: Date | undefined
  onDateChange: Function
  options?: BaseOptions
  onChange?: ChangeEventHandler<HTMLInputElement> | undefined
  dateMin?: Date
  dateMax?: Date
}

export const DatepickerPopup = forwardRef((props: DatepickerPopupProps, ref) => {
  const { options, date: originalDate, dateMin, dateMax } = props
  const [date, setDate] = useState(originalDate || null)
  const fpRef = useRef<any>(null)

  const handleDateChange = (date: Date) => {
    let newDate: Date | string = date
    if (date) {
      const mm = moment(date)
      newDate = mm.format('YYYY-MM-DDTHH:mm:ss')
    }
    props.onDateChange(newDate)
    setDate(date)
  }

  useEffect(() => {
    if (originalDate)
      setDate(originalDate)
  }, [originalDate])

  let inputDate = date
  if (date && typeof (date) === 'string') {
    const parsed = moment(date)
    inputDate = parsed.toDate()
  }

  return (
    <Flatpickr
      ref={fpRef}
      options={{
        dateFormat: 'd.m.Y',
        locale: Czech,
        position: 'below right',
        ...options,
        ...dateMin && { minDate: dateMin },
        ...dateMax && { maxDate: dateMax }
      }}
      value={inputDate || undefined}
      render={({ defaultValue, value, ...props }, ref) => {
        return (
          <Flex
            sx={{ gap: value ? 2 : 0 }}
            onClick={() => {
              if (!fpRef?.current?.flatpickr) return

              fpRef?.current?.flatpickr.open()
            }}
          >
            <Calendar color="secondary.500" />

            <Input
              sx={{
                width: value ? 'auto' : '0',
                height: 'auto',
                p: 0,
                bg: 'transparent',
                border: 'none',
                borderRadius: 'sm',
                _hover: { bg: 'transparent' },
              }}
              type="hidden"
              defaultValue={defaultValue}
              ref={ref}
              htmlSize={5}
            />
          </Flex>
        )
      }}
      onChange={([date]) => handleDateChange(date)}
      defaultValue=''
    />
  )
})
